
// Common

export const LOADING = 'LOADING'

// Login
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'

export const LOGIN_ERROR = 'LOGIN_ERROR'

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS'

export const PASSWORD_UPDATED_SUCCESS = 'PASSWORD_UPDATED_SUCCESS'

export const PASSWORD_UPDATED_ERROR = 'PASSWORD_UPDATED_ERROR'

// Maitrises

export const MAITRISES_FETCHED = 'MAITRISES_FETCHED'
export const ALL_MAITRISES_FETCHED = 'ALL_MAITRISES_FETCHED'
export const MAITRISES_DEACTIVATED = 'MAITRISES_DEACTIVATED'
export const MAITRISES_CLEARED = 'MAITRISES_CLEARED'
export const MAITRISES_ERROR = 'MAITRISES_ERROR'
export const MAITRISES_CREATED = 'MAITRISES_CREATED'
export const MAITRISES_UPDATED = 'MAITRISES_UPDATED'
export const MAITRISES_DELETED = 'MAITRISES_DELETED'

//Arrondissements

export const ARRONDISSEMENTS_FETCHED = 'ARRONDISSEMENTS_FETCHED'

// Secteurs

export const SECTEURS_DELETED = 'SECTEURS_DELETED'

export const SECTEURS_UPDATED = 'SECTEURS_UPDATED'


// Matériel

export const MATERIEL_FETCHED = 'MATERIEL_FETCHED'

export const MATERIEL_DELETED = 'MATERIEL_DELETED'

export const MATERIEL_UPDATED = 'MATERIEL_UPDATED'

export const MATERIEL_ERROR = 'MATERIEL_ERROR'

export const MATERIEL_CREATED = 'MATERIEL_CREATED'

// COLLECTE

export const COLLECTE_FETCHED = 'COLLECTE_FETCHED'

export const COLLECTE_DELETED = 'COLLECTE_DELETED'

export const COLLECTE_UPDATED = 'COLLECTE_UPDATED'

export const COLLECTE_ERROR = 'COLLECTE_ERROR'

export const CSV_ERROR_UNDEFINED = 'CSV_ERROR_UNDEFINED'

export const COLLECTE_CREATED = 'COLLECTE_CREATED'

export const COLLECTE_DOWNLOAD_TEMPLATE_FILE = 'COLLECTE_DOWNLOAD_TEMPLATE_FILE'

// Cantonniers

export const CANTONNIERS_FETCHED = 'CANTONNIERS_FETCHED'

export const ALL_CANTONNIERS_FETCHED = 'ALL_CANTONNIERS_FETCHED'

export const CANTONNIERS_DELETED = 'CANTONNIERS_DELETED'

export const CANTONNIERS_UPDATED = 'CANTONNIERS_UPDATED'

export const CANTONNIERS_ERROR = 'CANTONNIERS_ERROR'

export const CANTONNIERS_CREATED = 'CANTONNIERS_CREATED'

// Maps

export const MAP_CLEAR = 'MAP_CLEAR'

export const MAP_FILTER = 'MAP_FILTER'

export const MAP_SEARCHING = 'MAP_SEARCHING'

export const MAP_RESULT = 'MAP_RESULT'

export const MAP_ADD = 'MAP_ADD'

export const MAP_REALTIME_RESULTS = 'MAP_REALTIME_RESULTS'

export const MAP_MESSAGE = 'MAP_MESSAGE'

export const MAP_IMPLENTATIONMAT_RESULTS = 'MAP_IMPLENTATIONMAT_RESULTS'

// Demandes

export const DEMANDES_FETCHED = 'DEMANDES_FETCHED'

export const DEMANDE_DELETED = 'DEMANDE_DELETED'

export const DEMANDE_ERROR = 'DEMANDE_ERROR'

export const DEMANDES_EN_COURS_FETCHED = 'DEMANDES_EN_COURS_FETCHED'

// Notification

export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR'

export const NOTIFICATION_CREATED = 'NOTIFICATION_CREATED'

export const NOTIFICATION_DELETED = 'NOTIFICATION_DELETED'

// Csv

export const CSV_SUCCESS = 'CSV_SUCCESS'

export const CSV_ERROR = 'CSV_ERROR'

// Reporting

export const REPORTING_FETCHED = 'REPORTING_FETCHED'
export const REPORTING_ERROR = 'REPORTING_ERROR'
export const REPORTING_EMPTY = 'REPORTING_EMPTY'

// Users

export const USERS_FETCHED = 'USERS_FETCHED'

export const USERS_CLEARED = 'USERS_CLEARED'

export const USERS_ERROR = 'USERS_ERROR'

export const USER_CREATED = 'USER_CREATED'

export const USER_UPDATED = 'USER_UPDATED'

// Villes

export const VILLES_FETCHED = 'VILLES_FETCHED'

export const VILLES_UPDATED = 'VILLES_UPDATED'

export const VILLES_CLEARED = 'VILLES_CLEARED'

export const VILLES_ERROR = 'VILLES_ERROR'

// Collectivité

export const COLLECTIVITY_FETCHED = 'COLLECTIVITY_FETCHED'

export const TOURNEES_FETCHED = 'TOURNEES_FETCHED'

export const DECLARATIONS_FETCHED = 'DECLARATIONS_FETCHED'

export const TOURNEES_FILTERED = 'TOURNEES_FILTERED'

export const REMONTEES_GPS_FETCHED = 'REMONTEES_GPS_FETCHED'

export const INFO_TOURNEE = 'INFO_TOURNEE'

export const REALTIME_TOURNEES = 'REALTIME_TOURNEES'


export const MATERIELS_FETCHED = 'MATERIELS_FETCHED'
export const MATERIELS_DELETED = 'MATERIELS_DELETED'
export const MATERIELS_UPDATED = 'MATERIELS_UPDATED'
export const MATERIELS_DEACTIVATED = 'MATERIELS_DEACTIVATED'
export const MATERIELS_ERROR = 'MATERIELS_ERROR'
export const CANTONNIERS_DEACTIVATED = 'CANTONNIERS_DEACTIVATED'
export const USERS_UPDATED = 'USERS_UPDATED'
export const USERS_DEACTIVATED = 'USERS_DEACTIVATED'
export const USERS_DELETED = 'USERS_DELETED'
export const MODULE_BO_UPDATED = 'MODULE_BO_UPDATED'
export const MODULE_APK_UPDATED = 'MODULE_APK_UPDATED'



// new Types

// Matériel
export const ALL_MATERIELS_FETCHED = 'ALL_MATERIELS_FETCHED'

export const MATERIEL_DEACTIVATED = 'MATERIEL_DEACTIVATED'


// Matériel Permis

export const MATERIELSPERMIS_FETCHED = 'MATERIELSPERMIS_FETCHED'
export const MATERIELSPERMIS_ERROR = 'MATERIELSPERMIS_ERROR'

// Maitrises
export const MAITRISE_DEACTIVATED = 'MAITRISE_DEACTIVATED'
export const MAITRISE_CREATED = 'MAITRISE_CREATED'
export const MAITRISE_UPDATED = 'MAITRISE_UPDATED'

// Cantonniers


export const CANTONNIER_DEACTIVATED = 'CANTONNIER_DEACTIVATED'

export const CANTONNIER_UPDATED = 'CANTONNIER_UPDATED'

export const CANTONNIER_CREATED = 'CANTONNIER_CREATED'

// Secteurs

export const SECTEURS_FETCHED = 'SECTEURS_FETCHED'

export const SECTEUR_DEACTIVATED = 'SECTEUR_DEACTIVATED'

export const SECTEUR_UPDATED = 'SECTEUR_UPDATED'

export const SECTEUR_ERROR = 'SECTEUR_ERROR'

export const SECTEUR_CREATED = 'SECTEUR_CREATED'


// Demandes

export const DEMANDES_ERROR = 'DEMANDES_ERROR'

export const DEMANDE_CREATED = 'DEMANDE_CREATED'
export const DEMANDE_UPDATED = 'DEMANDE_UPDATED'
export const DEMANDE_CANCELED = 'DEMANDE_CANCELED'
export const DEMANDE_CANCELLATION_CLEAR = 'DEMANDE_CANCELLATION_CLEAR'
export const RELOAD_DEMANDS = 'RELOAD_DEMANDS'

// CONTENANT

export const CONTENANTS_FETCHED = 'CONTENANTS_FETCHED'

export const ALL_CONTENANTS_FETCHED = 'ALL_CONTENANTS_FETCHED'

export const CONTENANT_DEACTIVATED = 'CONTENANT_DEACTIVATED'

export const CONTENANT_UPDATED = 'CONTENANT_UPDATED'

export const CONTENANTS_ERROR = 'CONTENANTS_ERROR'

export const CONTENANT_CREATED = 'CONTENANT_CREATED'

export const CONTENANTS_FILTERED = 'CONTENANTS_FILTERED'

export const CONTENANTS_FEED_FILTERS = 'CONTENANTS_FEED_FILTERS'

// Users

export const USER_DELETED = 'USER_DELETED'
export const USER_DEACTIVATED = 'USER_DEACTIVATED'

// Admin

export const ALL_ARRONDISSEMENTS_FETCHED = 'ALL_ARRONDISSEMENTS_FETCHED'
export const ALL_ARRONDISSEMENTS_ERROR = 'ALL_ARRONDISSEMENTS_ERROR'
export const ALL_VILLES_FETCHED = 'ALL_VILLES_FETCHED'

export const REPORTING_FILTER_MATERIELS = 'REPORTING_FILTER_MATERIELS'

export const REPORTING_FILTER_DATES = 'REPORTING_FILTER_DATES'

export const REPORTING_FILTER_AGENTS = 'REPORTING_FILTER_AGENTS'

export const KPI = 'KPI'

// Tournees

export const TOURNEE_CLOSED = 'TOURNEE_CLOSED'

export const TOURNEE_ERROR = 'TOURNEE_ERROR'

export const MODULE_TOURNEES_FETCHED = 'MODULE_TOURNEES_FETCHED'






// WEBPACK FOOTER //
// ./src/store/mutations-types.js